export const PRODUCT_MAX_AMOUNT: number = 999
export const FILTERS_DEBOUNCE_MS = 400
export const FILTERS_STALE_TIME_MS = 5 * 60 * 1000
export const QUERY_KEY = {
  user: 'user',
  signUp: 'signUp',
  signIn: 'signIn',
  search: 'search',
  products: 'products',
  filters: 'filters',
  categories: 'categories',
  managers: 'managers',
  amount: 'amount',
  deleteProduct: 'deleteProduct',
  cart: 'cart',
  checkout: 'checkout',
  checkoutDetails: 'checkoutDetails',
  orders: 'orders',
  productCharacteristics: 'productCharacteristics',
  selectedFilters: 'selectedFilters',
  educationMode: 'educationMode',
  cities: 'cities',
  streets: 'streets',
  postoffices: 'postoffices',
  profile: 'profile',
  orderReview: 'orderReview',
  partnerProfile: 'partnerProfile',
}
export const HEADER_HEIGHT = '100px'
export const NAV_BAR_HEIGHT = '48px'
export const BREADCRUMBS_HEIGHT = '20px'
export const TABLE_ROW_HEIGHT = 33
export const TABLE_FOOTER_ROW_HEIGHT = 40
export const TABLE_HEAD_HEIGHT = '24px'
export const PROGRESS_BAR_HEIGHT = '5px'
